import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { getValueInRange } from '../../constants'
import SimpleButton from '../SimpleButton'

import styles from './index.css'

const INTERVAL_STEP = 50
const FINAL_INTERVAL_MS = 120
const INITIAL_INTERVAL_MS = 600

class NumberPicker extends PureComponent {
  componentWillUnmount() {
    this.stopChange()
  }

  changeBy = (amount) => {
    const { circular, max, min, value } = this.props
    const newValue = getValueInRange(value + amount, max, min, circular)
    if (value !== newValue) {
      this.props.onChange(newValue, value)
    }
  }

  changeInterval = INITIAL_INTERVAL_MS

  changeTimeout = null

  decrease = () => {
    this.changeBy(-1)
    this.timeoutAction(this.decrease)
  }

  increase = () => {
    this.changeBy(1)
    this.timeoutAction(this.increase)
  }

  onDecreaseKeyDown = ({ key }) => {
    if (key === 'Enter' || key === ' ') {
      this.changeBy(-1)
    }
  }

  onIncreaseKeyDown = ({ key }) => {
    if (key === 'Enter' || key === ' ') {
      this.changeBy(1)
    }
  }

  stopChange = () => {
    clearTimeout(this.changeTimeout)
    this.changeInterval = INITIAL_INTERVAL_MS
  }

  timeoutAction = (action) => {
    if (this.changeInterval > FINAL_INTERVAL_MS) {
      this.changeInterval -= INTERVAL_STEP
    }
    clearTimeout(this.changeTimeout)
    this.changeTimeout = setTimeout(action, this.changeInterval)
  }

  render() {
    const { ariaLabel, circular, className, max, min, value } = this.props
    const maxChars = Math.max(max.toString().length, min.toString().length)

    return (
      <div aria-label={ariaLabel} className={cn(styles.wrapper, className)}>
        <SimpleButton
          aria-roledescription={ariaLabel}
          ariaLabel="Aumentar"
          className={styles.button}
          disabled={!circular && value === max}
          icon="chevron up"
          onBlur={this.stopChange}
          onKeyDown={this.onIncreaseKeyDown}
          onKeyUp={this.stopChange}
          onMouseDown={this.increase}
          onMouseLeave={this.stopChange}
          onMouseUp={this.stopChange}
        />
        <div className={styles.number}>
          <div style={{ minWidth: `${maxChars * 0.7}em` }}>{value}</div>
        </div>
        <SimpleButton
          aria-roledescription={ariaLabel}
          ariaLabel="Disminuir"
          className={styles.button}
          disabled={!circular && value === min}
          icon="chevron down"
          itemsDirection="ttb"
          onBlur={this.stopChange}
          onKeyDown={this.onDecreaseKeyDown}
          onKeyUp={this.stopChange}
          onMouseDown={this.decrease}
          onMouseLeave={this.stopChange}
          onMouseUp={this.stopChange}
        />
      </div>
    )
  }
}

NumberPicker.propTypes = {
  value: PropTypes.number.isRequired,

  ariaLabel: PropTypes.string,
  circular: PropTypes.bool,
  className: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
}

NumberPicker.defaultProps = {
  ariaLabel: null,
  circular: false,
  className: '',
  max: 100,
  min: 0,
  onChange: Function.prototype,
}

export default NumberPicker
